import store from "@/store";
import UserSyncWebSocketService from "./userSyncWebsocketService";
import UserSyncSSEService from "./userSyncSSEService";
import { buildClientId, buildMercureSubscribePayload, buildSseTopics } from "./userSyncProfiles";
import { resolveSyncTransport } from "./resolveSyncTransport";
import { mercureRepository } from "./repository/mercureRepository";

class UserSyncService {
	static ACTION_ENABLE_MENU_BUTTON = 0;
	static ACTION_EVENT_WELCOME_GUEST = 23;

	constructor() {
		this.syncService = null;
		this.eventHandler = null;
	}

	async connect({ userId, transport = resolveSyncTransport() }) {
		this.disconnect();

		const clientId = buildClientId(userId);

		if (transport === "sse") {
			await mercureRepository.subscribe(buildMercureSubscribePayload());
			this.syncService = new UserSyncSSEService({
				topics: buildSseTopics(clientId),
			});
		} else {
			this.syncService = new UserSyncWebSocketService(clientId);
		}

		this.eventHandler = this.handleIncomingEvent.bind(this);
		this.syncService.addMessageListener(this.eventHandler);
		this.syncService.connect();
	}

	disconnect() {
		if (this.syncService && this.eventHandler) {
			this.syncService.removeMessageListener(this.eventHandler);
			this.syncService.disconnect();
		}
		this.syncService = null;
		this.eventHandler = null;
	}

	handleIncomingEvent(type, data) {
		if (type !== "message" || !data?.action) {
			return;
		}

		this.handleAction(data.action, data);
	}

	async handleAction(action, data) {
		switch (action) {
			case UserSyncService.ACTION_ENABLE_MENU_BUTTON:
				await store.dispatch("user/loadUserReservations");
				break;

			case UserSyncService.ACTION_EVENT_WELCOME_GUEST:
				store.commit("wePass/setEventWelcome", data.data);
				break;

			default:
				break;
		}
	}
}

export default new UserSyncService();
